import './polyfills'

import React from 'react'
import ReactDOM from 'react-dom'
import VConsole from 'vconsole'
import '@/styles/index.less'
import App from './App'
import * as serviceWorker from './serviceWorker'
// import * as Sentry from '@sentry/browser'
// import LogRocket from 'logrocket'
import Cookies from 'universal-cookie'
import 'url-search-params-polyfill'
import { injectJs2native } from './js2native'
// 引入阿里监控
// import ArmsUtils from './util/armsUtils'
  // 项目JS入口文件
  // import * as Sentry from '@sentry/browser'
/**
 * arms初始化配置
 */
 const option = {
  pid: 'bshv892lqv@a01daf2ecf57473',
  appType: 'web',
  environment: 'local',
  release: '1.0.0',
}
if (process.env.REACT_APP_ENV === 'development') {
  option.environment = 'local'
} else if (process.env.REACT_APP_ENV === 'test') {
  option.environment = 'test'
} else if (process.env.REACT_APP_ENV === 'production') {
  option.environment = 'prod'
}

// ArmsUtils.init(option)
if (process.env.REACT_APP_ENV === 'development') {
  // const voidFunc = () => {}
  // window.WebViewBridge = {
  //   shouldShowTabBar: voidFunc,
  //   userInfo: voidFunc,
  //   weChatPay: voidFunc,
  //   navBackMarket: voidFunc,
  //   aliPay: voidFunc,
  //   aliPayOld: voidFunc,
  //   getLocation: voidFunc,
  //   goToScanCode: voidFunc,
  //   addBillSuccess: voidFunc,
  //   goToPage: voidFunc,
  //   changeStore: voidFunc,
  //   roomInfo: voidFunc,
  //   goToJump: voidFunc,
  //   aboutUs: voidFunc,
  //   clearCache: voidFunc,
  //   privacyPolicy: voidFunc,
  //   setCache: voidFunc,
  //   logout: voidFunc,
  //   signIn: voidFunc,
  //   earnPoints: voidFunc,
  //   pageGoBack: voidFunc,
  //   pageGoForward: voidFunc,
  //   eventLabel: voidFunc,
  //   eventAttributes: voidFunc,
  // }
  const cookies = new Cookies()
  cookies.set('app_mall_depot_id', 1)
  cookies.set('app_mall_depot_name', '安心总部')
  cookies.set(
    'app_user_auth',
    'uAHZcf7RZfEzKi1N0frXJtHqlFGQgkUMXyN31I2ZGG0t5ZNYW3fAXg3w4gnqo8wq',
  )
  cookies.set('app_sign_key_mall', '765b3c619a7596e1b36a1303ad9d591d')
  cookies.set('checkin_id', '331279')
  localStorage.setItem('vConsole_switch_y', window.innerHeight / 2 + '');
  new VConsole()
}
console.log('processenv', process.env)
console.log('REACT_APP_ENV', process.env.REACT_APP_ENV)
console.log('xxxxxxxxxxx')
// 注释：打开则会导致打开页面后跟着打开一个about:blank
// if (process.env.REACT_APP_ENV === 'production') {
  // LogRocket.init('anxin/app-h5')
  // Sentry.init({
  //   dsn: 'https://6c50fac19558427d849657e6dfc91e0b@sentry.axhome.com.cn/9',
  // })
// }
ReactDOM.render(<App />, document.getElementById('root'))

injectJs2native(window)

function baiduInit() {
  const hm: any = document.createElement('script')
  hm.src = 'https://hm.baidu.com/hm.js?4a63c58f280eb180abbee4ff2c50aea4'
  const s: any = document.getElementsByTagName('script')[0]
  s.parentNode.insertBefore(hm, s)
}
baiduInit()

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
